
import axios from "axios";
import appconst from "@/lib/appconst";
import { Component, Vue } from "vue-property-decorator";

import PagedListBase, {
    PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import {
    FaceSettingService,
    PagedResultDtoPagedResultDto,
} from "@/api/service-proxies";
import Pagination from "@/components/Pagination/index.vue";

class PageUserRequest extends PagedRequestDto {
    name!: string;
}

@Component({
    name: "User",
    components: {
        Pagination,
    },
})
export default class extends PagedListBase<
    PageUserRequest,
    PagedResultDtoPagedResultDto
> {
    request = new PageUserRequest();
    private $http: any;

    private faceService = new FaceSettingService();

    created() {
        this.refresh();
    }

    getpage(finishCallback: Function): void {
        this.faceService
            .getAllSettings(
                this.request.name,
                this.request.sorting,
                this.request.skipCount,
                this.request.maxResultCount
            )
            .then((result) => {
                this.list = result.items;
                this.showPaging(result);
                this.isTableLoading = false;
            });
    }

    search() {
        this.refresh();
    }

    updateClearStudentFeatures(row){
      var id = row.tenantId;
        this.faceService.updateClearStudentFeatures(id).then((result) => {
          this.$notify.success("更新中。。。请稍后刷新查看");
        });
    }

    //更新人脸特征
    updateFeatures(row) {
        var id = row.tenantId;
        this.faceService.updateFeatures(id).then((result) => {
            this.$notify.success("更新中。。。请稍后刷新查看");
        }) ;
    }

    // updateCleareacherFeatures(row){
    //   var id = row.tenantId;
    //     this.faceService.updateClearTeacherFeatures(id).then((result) => {
    //         this.$notify.success(result.replace('\"',''));
    //     });
    // }

    // //更新教师人脸特征
    // updateTeacherFeatures(row) {
    //     var id = row.tenantId;
    //     this.faceService.updateTeacherFeatures(id).then((result) => {
    //       this.$notify.success("更新中。。。请稍后刷新查看");
    //     });
    // }
    updateCleareacherFeatures(row) {
    this.$message.success("指令已下发，请勿重复点");
    axios
      .get(
        appconst.remoteServiceBaseUrl + "/admin/api/services/app/TeacherUserExtra/GetDeleteTeacherModelAsync?SchooID=" + row.tenantId
      )
      .then((res) => {

      })
      .catch(() => {
        this.getpage
      })
      .finally(() => {
        this.getpage
      });

  }

    updateTeacherFeatures(row) {
    this.$message.success("指令已下发，请勿重复点");
    axios
      .get(
        appconst.remoteServiceBaseUrl + "/admin/api/services/app/TeacherUserExtra/GetTeacherPushModelAsync?SchooID=" + row.tenantId
      )
      .then((res) => {

      })
      .catch(() => {
        this.getpage
      })
      .finally(() => {
        this.getpage
      });

  }

}
